// extracted by mini-css-extract-plugin
module.exports = {"headerLink":"_7a231be"};